/**
 * Nyitó oldal központi komponens.
 *
 * @author Erik Banhalmi 2017.06.12.
 */

class HomeController {
	constructor($cookies, niceUrlService, NewsListerService, QoutationService, $translate) {
		'ngInject';
		this.newsListerService = NewsListerService;
		this.$cookies = $cookies;
		this.niceUrlService = niceUrlService;
		this.initData = {
			latestNews: {}
		};
		this.qoutationService = QoutationService;
		this.$translate = $translate;
	}

	$onInit() {
		let params = {
			page: 0,
			size: 3,
			lang: this.$translate.use()
		};
		this.newsListerService
			.getNewsList(params)
			.then(response => {
				this.initData.latestNews = response.data.content;
			})
			.catch(() => {
				console.log('hiba a hírek betöltésekor');
				this.initData.latestNews = [];
			});
		this.qoutationService
			.getEmployeeQoutations()
			.then(response => {
				this.initData.qoutation = Array.isArray(response.data) ? response.data[0] : {};
			})
			.catch(() => {
				console.log('hiba a dolgozói idézet betöltésekor');
			});
	}

	propertySearch(formData) {
		let niceUrl = this.niceUrlService.createNiceUrl(formData);
		if (niceUrl == '#/') {
			niceUrl = '';
		}
		window.location.href = '/kereses' + niceUrl;
	}
}

import NewsLister from './../../news/news-lister.module';
import niceUrlModule from './../../niceUrl/nice-url.module';
import quoteDisplayer from './../quote-displayer/quote-displayer';
import newsList from './../../news/news-list/news-list.module';
import propertySearchBar from './../property-search-bar/property-search-bar';
import propertyOffers from './../../property-offers/property-offers.module';
import financing from './../../financing/financing.module';
import careerOfferModule from './../../career/career-offer/career-offer.module';
import quotationModule from './../../qoutation-service/qoutation-service.module';

const MODULE_NAME = 'home';

export default angular
	.module(MODULE_NAME, [
		quoteDisplayer,
		newsList,
		propertySearchBar,
		niceUrlModule,
		propertyOffers,
		financing,
		careerOfferModule,
		NewsLister,
		quotationModule
	])
	.component('home', {
		transclude: true,
		controller: HomeController,
		templateUrl: 'home.html',
		bindings: {}
	}).name;
